export default {"src":"/_next/static/image/public/images/flags/flag_81.012dce73e7797800c9aba826a3fb70c7.svg","height":16,"width":24};